import React from 'react';
import { useDispatch } from 'react-redux';
import { Card, CardContent, Grid } from '@mui/material';

import { TabFab, usePagination, useSelection, useSettings, Utils } from 'app/main/components';
import { ViewList } from 'app/main/components/page-layouts';

import CommercialCampaignsDetailsSectionAddRows from '../sections/CommercialCampaignsDetailsSectionAddRows';
import CommercialCampaignsDetailsSectionDeleteRows from '../sections/CommercialCampaignsDetailsSectionDeleteRows';

import CommercialCampaignsRowsListItem from '../../commercialcampaigns-rows/CommercialCampaignsRowsListItem';

interface CommercialCampaignsRowsTabProps {
	table: string;
	model: any;
}

export default function CommercialCampaignsRowsTab(props: CommercialCampaignsRowsTabProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	// Can be edited only if draft or interrupted
	const canEdit = props.model.cmcp_cmst_id !== 4;

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	const paginationProps = usePagination({
		module: 'commercialcampaigns_rows',
		filter: {
			defaultFilters: [
				{ filt_field: 'cmrw_table', filt_clause: 'equals', filt_value: props.table },
				{ filt_field: 'cmrw_cmcp_uid', filt_clause: 'equals', filt_value: props.model.cmcp_uid }
			]
		},
		paginator: { defaultNRows: 100 }
	});

	const { selectedItems, setSelectedItems } = useSelection({
		module: 'commercialcampaigns_rows',
		isSelecting: canEdit
	});

	const onFabClick = () => {
		Utils.executeStored({
			action: 'st_commercialcampaigns_rows_delete',
			dispatch,
			data: {
				cmrw_cmcp_uid: props.model.cmcp_uid,
				values: selectedItems.map(item => item.cmrw_uid)
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				setSelectedItems([]);
				updateRefresh();
			}
		});
	};

	return (
		<Grid container spacing={2}>
			{canEdit && (
				<>
					<Grid size={{ md: 8, sm: 6, xs: 12 }}>
						<CommercialCampaignsDetailsSectionAddRows
							cmcpUid={props.model.cmcp_uid}
							table={props.table}
							isLoading={paginationProps.paginatorProps.isLoading}
							updateRefresh={updateRefresh}
						/>
					</Grid>
					<Grid size={{ md: 4, sm: 6, xs: 12 }}>
						<CommercialCampaignsDetailsSectionDeleteRows
							cmcpUid={props.model.cmcp_uid}
							table={props.table}
							isLoading={paginationProps.paginatorProps.isLoading}
							updateRefresh={updateRefresh}
						/>
					</Grid>
				</>
			)}
			<Grid size={12}>
				<Card variant="outlined" className="rounded-8">
					<CardContent className="p-0 last:p-0">
						<ViewList
							module="commercialcampaigns_rows"
							itemLayout={CommercialCampaignsRowsListItem}
							paginationProps={paginationProps}
							refresh={refresh}
							updateRefresh={updateRefresh}
							selectionProps={canEdit ? { mode: 'multiple', selectedItems } : undefined}
						/>
					</CardContent>
				</Card>
			</Grid>
			{selectedItems.length > 0 && (
				<TabFab label={t('VIEW_ITEM_BUTTON_DELETE')} icon="delete" onClick={onFabClick} />
			)}
		</Grid>
	);
}
